import React from "react";
import StarIcon from "@heroicons/react/16/solid/StarIcon";
import StarIconOutline from "@heroicons/react/24/outline/StarIcon";
import {usePhrase} from "../../i18n";




const ProductRatingWidget = ({count,average,_t}) => {


    const t = usePhrase(_t);


    return <div className={`flex space-x-1 mt-1`}>
        <p className={'text-sm'}><b>{parseFloat(average).toFixed(1)}</b></p>

        <div className={'flex space-x-0.5'}>
            {[...Array(Math.floor(average))].map((n, i) => <StarIcon
                key={'main_review_star_col_' + i} className={'h-5 w-5 text-[#e7bb43]'}/>)}
            {[...Array(5 - Math.floor(average))].map((n, i) => <StarIconOutline
                key={'main_review_star_uncol_' + i} className={'h-5 w-5 text-[#e7bb43]'}/>)}
        </div>
        <p className={'text-sm underline'}>
            {count} {t('reviews')}
            {/*<AnchorLink offset='150' href='#reviews' className={'underline'}>{getRatingCount()} {t('reviews')}
            </AnchorLink>*/}

        </p>
    </div>
}

export default ProductRatingWidget;